import { createSlice } from '@reduxjs/toolkit';
import { ChargerInfo, emptyCharger } from '../../models/charger-info';
import { ChargerAttributes, createEmptyCharger } from '../../models/charger-model';
import { ChargerHistoryAttributes } from '../../models/charger-history-model';

export interface ChargingSessionMetrics {
    orderId: string;
    baselineTimer: number;
    baselineKwh: number;
    baselinePrice: number;
    lastKnownServerTime: number;
    lastKnownServerKwh: number;
    lastKnownServerPrice: number;
    lastTimer: number;
    lastKwh: number;
    lastPrice: number;
}

interface ChargerData {
    chargerInputs: ChargerAttributes;
    chargers: ChargerAttributes[];
    chargerHistory: ChargerHistoryAttributes[];
    myChargers: ChargerAttributes[];
    selectedCharger: ChargerAttributes;
    chargingSessionMetrics: ChargingSessionMetrics | null;
}

const initialState: ChargerData = {
    chargerInputs: createEmptyCharger(),
    chargers: [],
    chargerHistory: [],
    myChargers: [],
    selectedCharger: createEmptyCharger(),
    chargingSessionMetrics: null,
}

const chargerSlice = createSlice ({
    name: 'chargers',
    initialState,
    reducers: {
        registerNewCharger(state, action) {
            //console.log('registerNewCharger', action.payload)
            state.chargerInputs = action.payload.chargerInputs;
        },
        getAllChargers(state, action) {
            //console.log('getAllChargers', action.payload);
            state.chargers = action.payload.chargers;
        },
        getChargerHistory(state, action) {
            //console.log('getChargerHistory', action.payload);
            state.chargerHistory = action.payload.chargerHistory;
        },
        getMyChargers(state, action) {
            //console.log('getMyChargers', action.payload);
            state.myChargers = action.payload.myChargers;
        },
        updateSelectedCharger(state, action) {
            //console.log('updateSelectedCharger', action.payload);
            state.selectedCharger = action.payload.selectedCharger;
        },
        clearAllChargers(state) {
            // Clear all charger data on logout
            state.chargers = [];
            state.myChargers = [];
            state.chargerHistory = [];
            state.selectedCharger = createEmptyCharger();
            state.chargingSessionMetrics = null;
        },
        setChargingSessionMetrics(state, action) {
            state.chargingSessionMetrics = action.payload;
        },
        clearChargingSessionMetrics(state) {
            state.chargingSessionMetrics = null;
        },
    }
})

export const chargerActions = chargerSlice.actions;
export default chargerSlice;
